<script>
    import { more } from '../stores'
    import { openFeedbackForm } from '../feedbackform';
	import { slide } from 'svelte/transition';
    import { __ } from '../utils/i18n';

    function escapeDrawer(e) {
        if (e.key == 'Escape') {
            $more=!$more;
        }
    }

    function resetDrawer() {
        $more=!$more;
    }   
</script>

<svelte:window on:keydown={escapeDrawer} />


{#if $more}
    <div class="infobox" transition:slide>
        <div class="close" tabindex="0" aria-label="{__('Select to close message')}" role="button" 
            on:click={resetDrawer}
            on:keypress={(e)=>{if (e.key === "Enter") resetDrawer()}}
        >
            <svg class="icon icon-close" aria-hidden="false" aria-label="X icon">
                <use href="#icon-close"/>
            </svg>
        </div>
        <h3>{__("Questions?")}</h3>
        <ul>
            <li>
                <h4>{__("What is this?")}</h4>
                <p>
                    {__("Shape Your L.A. helps the people of Los Angeles County get stuff done — on the issues that matter to you in your neighborhoods and beyond. The creators hope you will use this app to make positive changes in our communities, connect with neighbors and get more informed about civic life.")}
                </p>
            </li>
            <li>
                <h4>{__("What if I don’t have an address?")}</h4>
                <p>{@html __("If you are experiencing homelessness, you still have a right to representation and to vote. The Los Angeles Homeless Services Authority has information about how to register and vote at <a href='https://www.lahsa.org'>its website.</a>")}</p>
            </li>   
            <li>
                <h4>{__("I live in Los Angeles County but am registered to vote in another county or state.")}</h4>
                <p>{@html __("Now that you live here, <a href='https://registertovote.ca.gov/'>update your registration!</a>")}</p>
            </li>
            <li>
                <h4>{__("Is my address secure?")}</h4>
                <p>{__("Very secure! We don’t save your address in any capacity. We pass it along to determine your representatives and your civic boundaries, and that’s it!")}</p>
            </li>
            <li>
                <h4>{__("Where’s the data coming from?")}</h4>
                <p>{@html __("This project pulls information from <a href='https://developers.google.com/civic-information'>Google Civic Information</a>, a public data source that looks up your local representatives and districts based on your address. The maps are provided by the city of Los Angeles, L.A. County and We Draw the Lines CA.")}</p>
            </li>
            <li>
                <h4>{__("We want to hear from you!")}</h4>
                <p>{__("This project will evolve over time.")}
                    <a href="#" 
                        on:click={()=>$more=!$more} 
                        on:click={(e)=>openFeedbackForm()} 
                        class="feedback-special">{__("Let us know what you’d like to see next.")}</a>
                </p>
            </li>
        </ul>
    </div>
{/if}